import {createRouter, createWebHistory, useRoute} from "vue-router";
import {inject} from "vue";
import {useModal} from "@/js/Plugins/Modal.js";
import {useGlobalRoutes} from "@/js/routes.js";

class AppRouter {
    app;
    router;
    options = {
        public: false,
        twoFactorAuthentication: null
    };

    constructor(app, options) {
        this.app = app;
        this.router = createRouter({
            history: createWebHistory(),
            routes: [...useGlobalRoutes(), ...options.routes].map((route) => {
                if (!route.path.match(__PREFIX__)) {
                    route.path = `/${__PREFIX__}${route.path}`;
                }
                return route;
            })
        });

        this.options.public = options?.public;
        this.options.twoFactorAuthentication = options?.twoFactorAuthentication;


        this.router.beforeEach(this._handleBeforeEach.bind(this));
        this.router.afterEach(this._handleAfterEach.bind(this));

        const originalBackFn = this.router.back.bind(this.router);
        this.router.back = () => {
            const state = this.router.options.history.state
            const hasBack = !!state && (state.position ?? 0) > 0 && !!state.back;

            if (hasBack) {
                return originalBackFn();
            }

            const route = this.router.currentRoute.value;
            const goToRoute = route.matched.length > 2 ? route.matched[route.matched.length - 2] : route.matched[0];

            this.router.replace({ name: goToRoute.name });
        }

        this.router.childRoute = function (name) {
            return `${this.currentRoute.value.name}.${name}`;
        }
        app.config.globalProperties.$store.state.router = this.router;

        app.provide('app-router', this.router);
        app.use(this.router);
    }


    _handleBeforeEach(to, from, next) {
        const modal = useModal();
        if(modal) {
            useModal().closeAll();
        }

        if (this.options.twoFactorAuthentication) {
            const provider = this.options.twoFactorAuthentication.provider;
            if (this.options.twoFactorAuthentication?.enabled) {
                if (to.name === '2fa.login') {
                    return next();
                }
                this.router.push({ name: '2fa.login', params: { provider }});
                return;
            }
            if (to.name === '2fa.setup') {
                return next();
            }
            this.router.push({ name: '2fa.setup', params: { provider }})
            return;
        }

        if (to.path === `/${__PREFIX__}`) {
            return next({ name: 'map.objects.list' });
        }

        const fromRootName = from.matched[0]?.name;
        const toRootName = to.matched[0]?.name;
        if (fromRootName !== toRootName && !to.meta?.confirm) {
            this.app.config.globalProperties.$loader.show();
        }

        return next();
    }

    _handleAfterEach(to, from) {
        this.app.config.globalProperties.$emitter.emit('app:ready');
    }
}

export default {
    install(app, options = {}) {
        const http = new AppRouter(app, options);
        app.provide('custom-app-router', http);
    }
}

export function useAppRouter() {
    return inject('custom-app-router');
}

export function useRoutePrefix()
{
    return useRoute().matched[0].name.split('.')[0];
}